// extracted by mini-css-extract-plugin
export var apartmentInput = "address-delivery-fields-module--apartment-input--71c0c";
export var cityInput = "address-delivery-fields-module--city-input--9391c";
export var contactInput = "address-delivery-fields-module--contact-input--d4e9c";
export var container = "address-delivery-fields-module--container--829f1";
export var houseInput = "address-delivery-fields-module--house-input--b87e9";
export var phoneInput = "address-delivery-fields-module--phone-input--22248";
export var streetInput = "address-delivery-fields-module--street-input--5475c";
export var zipInput = "address-delivery-fields-module--zip-input--31ce4";